import React from 'react';
import { formatLeaveCount } from '../../utils/leaveSummary';

const LEAVE_TYPE_ROWS = [
  { key: 'earnedLeave', label: 'Earned Leave (EL)', color: 'text-[#B8130F]' },
  { key: 'sickLeave', label: 'Sick Leave (SL)', color: 'text-[#D3A33D]' },
  { key: 'casualLeave', label: 'Casual Leave (CL)', color: 'text-[#16A34A]' },
  { key: 'lopLeave', label: 'Loss Of Pay (LOP)', color: 'text-[#7C3AED]' },
];

function SummaryValue({ isLoading, value }) {
  return (
    <span className="font-semibold text-gray-900">
      {isLoading ? '—' : formatLeaveCount(value)}
    </span>
  );
}

function LeaveBalanceSummary({ summary, isLoading = false, compact = false }) {
  return (
    <div className={compact ? '' : 'rounded-2xl border border-gray-100 bg-white p-4 shadow-sm sm:p-5'}>
      <div className={`grid gap-3 ${compact ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-4'}`}>
        {LEAVE_TYPE_ROWS.map((row) => {
          const typeSummary = summary?.[row.key] || { total: 0, used: 0, remaining: 0 };
          return (
            <div
              key={row.key}
              className="rounded-lg border border-gray-100 bg-[#faf8f5] px-3 py-3"
            >
              <p className={`font-semibold ${row.color} ${compact ? 'text-xs' : 'text-sm'}`}>
                {row.label}
              </p>
              <div className={`mt-3 grid grid-cols-3 gap-2 text-center ${compact ? 'text-xs' : 'text-sm'}`}>
                <div>
                  <p className="text-gray-500">Total</p>
                  <p className="mt-0.5 font-semibold text-gray-900">
                    <SummaryValue isLoading={isLoading} value={typeSummary.total} />
                  </p>
                </div>
                <div>
                  <p className="text-gray-500">Used</p>
                  <p className="mt-0.5 font-semibold text-gray-900">
                    <SummaryValue isLoading={isLoading} value={typeSummary.used} />
                  </p>
                </div>
                <div>
                  <p className="text-gray-500">Remaining</p>
                  <p className="mt-0.5 font-semibold text-gray-900">
                    <SummaryValue isLoading={isLoading} value={typeSummary.remaining} />
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LeaveBalanceSummary;
